/* global axios */
import ApiClient from '../ApiClient';

class CaptainUsage extends ApiClient {
  constructor() {
    super('captain/usage', { accountScoped: true });
  }

  // Admin-only aggregate AI spend for the account over a window. `since`/`until`
  // are ISO strings the backend parses with `Time.zone.parse`; both are optional
  // (the endpoint defaults to the trailing 30 days).
  getUsage({ since, until, signal } = {}) {
    const requestConfig = { params: {} };
    if (since) requestConfig.params.since = since;
    if (until) requestConfig.params.until = until;
    if (signal) requestConfig.signal = signal;

    return axios.get(this.url, requestConfig);
  }
}

export default new CaptainUsage();
